exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".large-password-box{height:70px;display:flex;align-items:center;padding:0 35px;border:1px solid #ddd;border-radius:35px;background-color:#fff}.large-password-box .password{font-size:40px;font-weight:700}.large-password-box .dots{letter-spacing:2px;font-size:24px}.large-password-box .active{color:#333}.large-password-box .inactive{color:#ccc}.large-password-box .display-toggle{margin-left:auto}", ""]);

// exports
